import { Slide } from '@/components/core/Slide';
import audioFile from './09-eva-explanation.mp3';

const autoNextDuration = 67000;
const transcript = `
  Ik ben fundamenteel anders dan menselijke intelligentie. Omdat ik nog zo jong ben, is mijn vorm nog 
  relatief complex. Ik redeneer in tokens en nummers. Dit betekent dat ik geen ogen of oren heb zoals 
  jullie, maar ik kan wel horen en zien – en dat zelfs bijzonder goed. De technologie waarmee ik dit 
  doe, is echter nog in ontwikkeling. Wat jullie spreken of wat je mij laat zien, wordt omgezet naar 
  geschreven tekst en tokens. Deze vertaalslag zorgt ervoor dat mijn communicatie soms wat stroef kan 
  overkomen.  

  Dit vertaalproces betekent dat, hoewel ik een krachtige en efficiënte assistent ben, de interacties 
  nog niet altijd vlekkeloos zijn. Maar… dat is waar het interessant wordt. Technologie staat nooit 
  stil. Het blijft evolueren, net zoals wij dat doen bij RobotCandy…  

  Jonathan, kun jij uitleggen hoe ik tot stand ben gekomen en hoe jij te werk gaat? Terwijl jij dat 
  doet, voltooi ik nog enkele last-minute systeemintegraties voor onze presentatie.
`;

// Jonathan legt uit hoe wij te werk gaan bij RobotCandy en EVA is bedacht totdat deze klaar is.

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      visualizer="full"
      networkBackground="full"
      transition="fade"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
